/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Layout, Row, Skeleton, notification } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../axios_instance';
import { ProfileSearchCriteriaList } from '../../../../utils/option-list';
import PaginationComponent from '../../../general/pagination';
import Search from '../../../general/search';
import ProfileList from '../../../uicontainers/admin/profile-list';
import styles from './styles.module.scss';

// const style: React.CSSProperties = { background: '#0092ff', padding: '8px 0' };

const ProfileListView: React.FC = (): JSX.Element => {
  const [employeeList, setEmployeeList] = useState<Array<any>>([]);
  const [page, setPage] = useState<number>(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [url, setUrl] = useState<string>(`/api/v1/admin/profiles/?`);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [disabledSearch, setDisabledSearch] = useState<boolean>(false);
  const navigation = useNavigate();
  const location = useLocation();

  const openNotification = (
    notificationType: 'success' | 'info' | 'warning' | 'error'
  ) => {
    notification[notificationType]({
      message: 'An error occurred!List can not load right now!',
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const pageNumber = parseInt(params.get('page-number') || '1', 10);
    setPage(pageNumber);
  }, [location.search]);

  const updateUrlWithPageNumber = (pageNumber: number) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('page-number', pageNumber.toString());
    navigation({ search: searchParams.toString() });
  };

  // Use updateUrlWithPageNumber function in your axiosInstance.get calls
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const pageNumber = parseInt(params.get('page-number') || '1', 10);
    setIsLoading(true);
    axiosInstance
      .get(url + 'page-number=' + pageNumber)
      .then((response) => {
        setEmployeeList(response.data.items);
        setTotal(response.data['total_items']);
      })
      .catch((error) => {
        openNotification('error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(
        url.charAt(url.length - 1) === '&' ? url.slice(0, url.length - 1) : url
      )
      .then((response) => {
        setEmployeeList(response.data.items);
        setTotal(response.data['total_items']);
      })
      .catch((error) => {
        openNotification('error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [url]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const pageNumber = parseInt(params.get('page-number') || '1', 10);
    setIsLoading(true);
    axiosInstance
      .get(
        url +
          (url.charAt(url.length - 1) === '?'
            ? 'page-number='
            : '&page-number=') +
          pageNumber
      )
      .then((response) => {
        setEmployeeList(response.data.items);
      })
      .catch((error) => {
        openNotification('error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [page]);

  return (
    <>
      <h1 className={styles['page-title']}>Employee</h1>
      <div
        style={{ position: 'fixed', top: '164px', width: '100%', zIndex: 2 }}
      >
        <Row align={'middle'}>
          <Col span={12}>
            <Search
              {...{ setUrl, setPage, disabledSearch }}
              baseUrl={`/api/v1/admin/profiles/`}
              searchCriteriaList={ProfileSearchCriteriaList}
            />
          </Col>
          <Col span={12}>
            <span
              style={{
                marginLeft: '20px',
                color: '#9E9E9E',
                fontFamily: 'Open Sans',
                fontWeight: '400',
              }}
            >
              {total + ' employees found'}
            </span>
          </Col>
        </Row>

        <br />
      </div>

      {/* <EmployeeList employeeList={employeeList.slice((page-1)*pageSize,Math.min(employeeList.length, page*pageSize))}/> */}
      <div
        style={{
          height: '226px',
          width: '100%',
          position: 'fixed',
          top: 1,
          background: '#f9fafd',
          zIndex: 1,
        }}
      ></div>
      {/* <div style={{marginTop:"216px"}}> */}
      {isLoading ? (
        <Layout className={styles.layout}>
          <Content className={styles.container}>
            <Skeleton active /> <Skeleton active /> <Skeleton active />
          </Content>
        </Layout>
      ) : (
        <ProfileList employeeList={employeeList} />
      )}
      {/* </div> */}

      <div
        style={{
          marginLeft: 'auto',
          marginRight: '10px',
          marginTop: '10px',
          marginBottom: '20px',
          float: 'right',
        }}
      >
        <PaginationComponent
          pageNumber={page}
          total={total}
          setPageNumber={updateUrlWithPageNumber}
          pageSize={pageSize}
        />
      </div>
    </>
  );
};

export default ProfileListView;
